exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mv-22[data-v-6d488c6d] {\n  margin: 22px 0;\n}\n.v-middle[data-v-6d488c6d] {\n  vertical-align: middle !important;\n}\na[data-v-6d488c6d] {\n  color: #007bff;\n  text-decoration: none;\n}\na[data-v-6d488c6d]:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}", ""]);

// exports
